import { useGetNodeValue } from "../useGetNodeValue.ts";
import { valueSubtypeMismatchCreate, type ValueSubtypeMismatch } from "../valueSubtypeMismatch.ts";

export const useValueSubtypeMismatch = (): ValueSubtypeMismatch =>
  valueSubtypeMismatchCreate({ getNodeValue: useGetNodeValue() });
